import axios from "axios";

export const urlBase = process.env.REACT_APP_API_URL;

const urlChat = `${urlBase}/public/v1/fe/`;
const urlChatV2 = `${urlBase}/public/v2/fe/`;

const getConfigChatweb = async (channelId) => {
  try {
    const res = await axios.get(`${urlChatV2}channel-info`, {
      params: { channelId },
    });
    return res.data;
  } catch (error) {
    console.error('getConfigChatweb error:', error.response?.data || error);
    throw error;
  }
}

const ConfigChatwebAPI = {
    getConfigChatweb,
}

export default ConfigChatwebAPI